<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h3 class="title font-medium text-2xl">
        {{ $t("common.notification") }}
      </h3>
    </div>
    <div class="md-layout-item">
      <md-card>
        <md-card-content v-if="notifications.length">
          <div
            @click="LoadMoreNotification"
            :class="getClassBell(item)"
            v-for="(item, index) in notifications"
            :key="index"
          >
            <div class="flex items-center">
              <div class="pr-5">
                <i class="fas fa-bell bell object-cover rounded-full"></i>
              </div>
              <div>
                <p :class="getClassTitle(item)">{{ item.title }}</p>
                <p class="description">
                  {{ item.created_at | formatDateTime(userTz) }}
                </p>
                <p>{{ item.contents }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="notifications.length % 10 === 0 && notifications.length !== 0"
          >
            <a class="load-more pt-6 pb-3" @click="LoadMoreNotification">
              Load more ...
            </a>
          </div>
        </md-card-content>
        <md-card-content v-else>
          <div class="flex justify-center">
            <no-data-found></no-data-found>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { mapGetters, mapMutations } from "vuex";
import { getId } from "@/helpers/utils";
import moment from "moment";
import { convertTimeByTimezone } from "../../helpers/datetime-helper";
export default {
  data() {
    return {
      notifications: {},
      limit: 10
    };
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info",
      userTz: "timezone"
    })
  },
  created() {
    if (this.userInfo) {
      this.fetchNotification(this.userInfo);
    }
  },
  filters: {
    formatDateTime(date, userTimeZone) {
      return convertTimeByTimezone(
        date,
        "Etc/UTC",
        userTimeZone ?? moment.tz.guess(),
        "dddd, MMMM DD, YYYY hh:mm a"
      );
    }
  },
  watch: {
    userInfo: function(newVal, oldVal) {
      this.fetchNotification(newVal);
    }
  },
  beforeDestroy() {
    this.readAllNotifications();
  },
  methods: {
    ...mapMutations("fcm", ["decreaseNotifyTotal", "resetTotalNotify"]),
    readAllNotifications() {
      const path = `${service_paths.notifications}/user/${getId(
        this.userInfo
      )}/read-all-notifications`;
      this.$axios
        .get(
          path,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false,
          false
        )
        .then(() => {
          this.resetTotalNotify();
        });
    },
    getClassBell(item) {
      return item.time_read ? "md-layout py-3" : "md-layout py-3 bell-bold";
    },
    getClassTitle(item) {
      return item.time_read
        ? "title-notification pb-1 blur-title"
        : "title-notification pb-1";
    },
    LoadMoreNotification() {
      this.limit += 10;
      this.fetchNotification(this.userInfo);
    },
    fetchNotification(userInfo) {
      this.$axios
        .get(
          `${service_paths.notifications}/user/${getId(userInfo)}`,
          {
            limit: this.limit
          },
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.notifications = response.data.data;
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.bell {
  background-color: #ddd;
  width: 50px;
  height: 50px;
  font-size: 25px;
  line-height: 50px;
  text-align: center;
  color: white;
}
.md-layout {
  border-bottom: 1px solid #ddd;
}
.bell-bold {
  i {
    background-color: rgb(92, 176, 80);
  }
}
.title-notification {
  font-weight: 400;
  font-size: 18px;
}
.blur-title {
  color: rgb(192, 188, 188);
}
.load-more {
  display: flex;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
}
</style>
